import { EntityLink } from '@/shared/ui/entity-link'

interface EntityRefProps {
  id: string
  label?: string
  className?: string
}

export function VoiceLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink
      to="/voices/$voiceId"
      params={{ voiceId: id }}
      icon="mic"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}
